import React, { Component } from 'react';
import styled from 'styled-components';
import { colors } from '../../style-utilities/variables';
import {
  ReviewsStateContext,
  ReviewsStateConsumer
} from '../../context/ReviewsContext';
import RegularButton, { Button } from '../RegularButton';
import Rating from 'react-rating';
import ReactHtmlParser from 'react-html-parser';
import placeHolderImage from '../../images/placeholder.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';

import ComponentStyles from '../../brand-styles/components/Reviews/ReviewsAddEdit.styles';


const ReviewsAddStyle = styled.div`
  background: white;
  margin: 10px auto;
  display: block;

  h2 {
    color: ${colors.primary};
    font-size: 22px;
    margin-bottom: 8px;
  }

  .form-margin {
    margin-bottom: 10px;
    width: 95%;
  }

  button {
    display: inline-block;
    margin: 20px 10px;
  }
  textarea {
    height: 270px;
    width: 90%;
    border: 1px solid lightgray;
  }

  .small {
    font-size: 12px;
  }

  .small-bottom-margin {
    margin-bottom: 5px;
  }

  .error {
    color: red;
  }

  .remove-left-padding {
    padding-left: 0px;
  }

  .align-right {
    text-align: right;
    padding-right: 2.5%;
  }

  ${Button} {
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .check-label {
    cursor: pointer;
  }

  .profile {
    text-align: center;
    img {
      width: 70px;
      border-radius: 50%;
    }
  }

  /* Dynamic brand styles */
  ${ComponentStyles}
`;

class ReviewsAddEdit extends Component {
  componentDidMount() {}

  onChangeHandler = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.context.setExistingReviewState({
      [name]: value
    });
  };

  onStarChange = value => {
    this.context.setExistingReviewState({
      stars: value
    });
  };

  add = event => {
    event.preventDefault();

    const type = this.props.type;
    const slug = this.props.slug;
    const item = this.context.getExistingReviewState();

    const errors = {};

    if (!item.title) {
      errors.title = 'Title is required.';
    }

    if (!item.text) {
      errors.text = 'Comments are required.';
    }

    if (Object.keys(errors).length) {
      this.context.setExistingReviewErrors(errors);
    } else {
      this.context.setExistingReviewErrors(errors);
      this.context.add(type, slug, item).then(() => {
        this.props.onClose();
      });
    }
  };

  cancel = event => {
    event.preventDefault();

    this.context.setExistingReviewErrors({});
    this.props.onClose();
  };

  render() {
    return (
      <ReviewsStateConsumer>
        {reviewsStateContext => {
          const { existingReview, existingReviewErrors } = reviewsStateContext;

          const hasExistingReview = existingReview && existingReview.id;

          return (
            <ReviewsAddStyle>
              <h2>{hasExistingReview ? 'Edit Review' : 'Write a Review'}</h2>
              <form>
                <div className="profile">
                  {!existingReview.hideProfileImage && (
                    <img
                      src={
                        existingReview.userAvatar
                          ? existingReview.userAvatar
                          : placeHolderImage
                      }
                      alt="authorProfile"
                    />
                  )}
                </div>
                <div>
                  <label className="form-margin check-label">
                    <input
                      name="hideProfileImage"
                      type="checkbox"
                      checked={existingReview.hideProfileImage}
                      onChange={this.onChangeHandler}
                    />
                    &nbsp;&nbsp; Do not show my profile image on review
                  </label>
                </div>
                <hr className="form-margin" />
                <div className="small small-bottom-margin">
                  Provide a Rating:
                </div>
                <div className="form-margin">
                  <Rating
                    emptySymbol={<FontAwesomeIcon icon={faStar} size="2x" />}
                    fullSymbol={
                      <FontAwesomeIcon icon={faStarSolid} size="2x" />
                    }
                    initialRating={existingReview.stars}
                    onClick={this.onStarChange}
                    fractions={2}
                  />
                </div>
                <div className="small small-bottom-margin align-right">
                  *Required Fields
                </div>
                <div>
                  {/* <label>Review Title*</label> */}
                  <input
                    type="text"
                    name="title"
                    placeholder="Review Title*"
                    value={ReactHtmlParser(existingReview.title)}
                    onChange={this.onChangeHandler}
                    className="form-margin remove-left-padding"
                  />
                </div>
                {existingReviewErrors.title && (
                  <p className="small error">{ReactHtmlParser(existingReviewErrors.title)}</p>
                )}
                <div>
                  {/* <label>Comments*</label> */}
                  <textarea
                    name="text"
                    placeholder="Comments*"
                    value={existingReview.text}
                    onChange={this.onChangeHandler}
                    className="form-margin"
                  />
                </div>
                {existingReviewErrors.text && (
                  <p className="small error">{existingReviewErrors.text}</p>
                )}

                <RegularButton onClick={this.add}>
                  {hasExistingReview ? 'Update' : 'Add'}
                </RegularButton>
                <RegularButton onClick={this.cancel}>Cancel</RegularButton>
              </form>
            </ReviewsAddStyle>
          );
        }}
      </ReviewsStateConsumer>
    );
  }
}

ReviewsAddEdit.contextType = ReviewsStateContext;

export default ReviewsAddEdit;
